import { useQuery } from '@tanstack/react-query';

import { useProfile } from 'context/profile';
import { indexGroups, IndexParams } from 'services/api/group';

export default function usePrefetchGroups(groupTypeApiName: string, options?: IndexParams) {
  const { profile } = useProfile();

  const groupType = profile.actingClient.groupTypes.find((gt) => gt.apiName === groupTypeApiName);
  const groupParams = { groupType: groupType?.id, sortBy: 'name asc', ...options };

  const query = useQuery({
    queryKey: ['groups', 'prefetch', groupParams],
    queryFn: ({ signal }) => indexGroups({ ...groupParams, pageSize: 1 }, signal),
  });

  return { groupType, groupParams, query };
}
